<template>
  <v-row justify="center">
    <v-dialog
      max-width="700px"
      :value="isVisible"
      persistent
      @keydown.esc="closeModal"
    >
      <v-card style="background-color: #D9D9D9;">
        <v-card-title>
          <span class="headline sub-title">
            {{ label }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-for="courseTicketLink in links" :key="courseTicketLink.id">
              <p @click="handleClickedCourseTicketLink(courseTicketLink.id)">
                <a
                  :href="courseTicketLink.link"
                  style="color: #8B857D;"
                  target="_blank"
                  >{{ courseTicketLink.name }}</a
                >
              </p>
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="#8B857D" text v-on:click="closeModal">
            <font-awesome-icon icon="times" class="mr-1" />
            Zamknij
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "RefLinksInfoModal",
  props: [
    "isVisible",
    "label",
    "userId",
    "links",
    "handleClickedCourseTicketLink",
  ],

  data: () => ({}),
  methods: {
    closeModal() {
      this.email = "";
      this.$emit("closeModal");
    },
  },
};
</script>
<style type="scss" scoped>
.headline {
  margin-bottom: 2rem;
  word-break: break-word;

}

a {
  color: #54514c;
}

@media screen and (max-width: 500px) {
  .headline {
    font-size: 18px !important;
    word-break: break-word;
  }
}
</style>
